import { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, FloatingLabel, FormControl, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../services/PrivateApiService";
import Validator from "../../services/Validator";
import { useAuthDispatch, useAuthState } from "../../context/AuthContext";
import { FaArrowDown, FaArrowRight } from "react-icons/fa";
import { BsFillBuildingsFill } from "react-icons/bs";
import { Typeahead } from "react-bootstrap-typeahead";
import { useQuery, useQueryClient } from "react-query";
import { FaCircleCheck, FaCircleXmark, FaXmark } from "react-icons/fa6";
import EmployeeStage from "../anlage/new_anlage/EmployeeStage";

const ChangeHwModal = ({building, show, setShow}) => {

    const API = new PrivateApi();
    const VALIDATOR = new Validator();
    const queryClient = useQueryClient();
    const { user, contactPerson } = useAuthState();
    const dispatch = useAuthDispatch();
    const [view, setView] = useState("contactPerson");
    const [apiError, setApiError] = useState("");

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [formErrors, setFormErrors] = useState({});
    const [hwSearchList, setHwSearchList] = useState([]);
    const [selectedHw, setSelectedHw] = useState(null);

    const { data } = useQuery("GET_ALL_HWS", API.hw_all, { staleTime: Infinity });


    useEffect(() => {
        if (show === true) {
            if (contactPerson === null || contactPerson === undefined) setView("contactPerson");
            else setView("default");
            setName("");
            setEmail("");
            setFromDate("");
            setSelectedHw(null);
        }
    }, [show])

    useEffect(() => {
        if (name !== undefined && name.length > 0) {
            if (data.data.length > 0) {
                const filtered = data.data.filter(item => item.name.toLowerCase().includes(name.toLowerCase())).map(item => item.name);
                setHwSearchList(filtered);
            }
        }
        else {
            setEmail("");
            setHwSearchList([]);
        }
    }, [name])


    const hwSelectedFromListHandler = (hwSelected) => {
        setName(hwSelected);
        if (data.data.length > 0 && hwSelected !== "") {
            const filtered = data.data.find(obj => obj.name === hwSelected);
            setSelectedHw(filtered);
            if (filtered) {
                setEmail(filtered.email);
            } 
        }
    }

    const deselectHwSelected = (e) => {
        e.preventDefault();
        setSelectedHw(null);
        setName("");
        setEmail("");
    }

    const sendData = () => {
        var tempError = {};

        // checks
        if (selectedHw === null) {
            if (!VALIDATOR.StringLength(4, 100, name)) tempError.name = true;
            if (!VALIDATOR.EmailValid(email)) tempError.email = true;
        }
        if (!VALIDATOR.dateValid(fromDate)) tempError.fromDate = true;

        if (Object.keys(tempError).length > 0) {
            return setFormErrors(tempError);
        }

        setView("loading");
        var data = {building: building, name:name, email:email, from_date:fromDate, contact_person: contactPerson}
        if (selectedHw !== null) data.selectedHw = selectedHw;
  
        API.hw_change(data)
            .then(() => {
                queryClient.invalidateQueries("GET_BUILDINGS_QUERY")
                setView("done");
            })
            .catch(err => {
                if (err.response.data.detail && err.response.data.detail !== "") {
                    setApiError(err.response.data.detail)
                } else {
                    setApiError("Unbekanter Fehler aufgetreten.")
                }
                setView("error");
        });
    }

    const resetContatPerson = (e) => {
        e.preventDefault();
        dispatch('CLEAR_CONTACT');
        setView("contactPerson");
    }

    return (
        <Modal size="lg" show={show} onHide={() => setShow(false)}>
            <ModalHeader closeButton>
                <ModalTitle>Hausverwaltung-Wechsel</ModalTitle>
            </ModalHeader>
            {
                view === "contactPerson" ? 
                    <div className="m-2">
                        <EmployeeStage setStage={setView} setShow={setShow} />
                    </div> :
                view === "default" ? 
                    <ModalBody>
                        <p className="text-muted">
                            Hier können Sie den Wechsel eines Objekts zu einer 
                            anderen Hausverwaltung einleiten. Damit der Übergang 
                            reibungslos funktioniert, und wir alle weiteren 
                            Schritte einleiten können, bitten wir Sie um die 
                            Bekanntgabe folgender Informationen.
                        </p>
                        <Row className="mt-4 mb-3">
                            <Col xs="12" md="5" xl="5">
                                <Card bg="energo">
                                    <CardBody>
                                        <Row>
                                            <Col>
                                                <BsFillBuildingsFill size={30} style={{marginRight: 10}} />
                                                {building?.name}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <small>{user.name}</small>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <div className="d-flex flex-column mt-3">
                                    <small>Kontaktperson:</small>
                                    <a onClick={e => resetContatPerson(e)} href="/kontaktPerson/auswählen/" className="link-energo">{contactPerson?.name}</a>
                                </div>
                            </Col>
                            <Col xs="12" md="2" xl="2" className="text-center text-energo hide-on-medium-and-small mt-4">
                                <FaArrowRight size={30} />
                            </Col>
                            <Col xs="12" md="2" xl="2" className="text-center text-energo hide-on-big">
                                <FaArrowDown size={30} />
                            </Col>
                            <Col xs="12" md="5" xl="5">
                                <div className="flex flex-column gap-2">
                                        <Card bg="energo" hidden={selectedHw === null}>
                                            <CardBody>
                                                <a 
                                                    href="/entfernen" 
                                                    className="link-danger"
                                                    style={{position: "absolute", right: 10, top: 0}}
                                                    onClick={e => deselectHwSelected(e)}
                                                >
                                                    <FaXmark/>
                                                </a>
                                                <div className="d-flex flex-column gap-2 text-center">
                                                    {selectedHw?.name}
                                                    <small>{selectedHw?.email}</small>
                                                </div>
                                            </CardBody>
                                        </Card>
                                        {selectedHw === null &&
                                            <>
                                                <Typeahead
                                                    id="hw-autocomplete"
                                                    style={{height: "56px"}}
                                                    placeholder="Neue Hausverwaltung"
                                                    defaultInputValue={name}
                                                    onInputChange={(text, e) => setName(text)}
                                                    onChange={e => hwSelectedFromListHandler(e[0])}
                                                    options={hwSearchList}
                                                    isValid={name !== undefined && name.length > 3}
                                                    isInvalid={formErrors.name}
                                                />
                                                <FloatingLabel label='E-Mail-Adresse'>
                                                    <FormControl
                                                        placeholder='E-Mail-Adresse'
                                                        value={email}
                                                        onChange={e => setEmail(e.target.value)}
                                                        isValid={VALIDATOR.EmailValid(email)}
                                                        isInvalid={formErrors.email}
                                                    />
                                                </FloatingLabel>
                                            </>
                                        }
                                    <FloatingLabel label="Datum des Wechsels">
                                        <FormControl
                                            type="date"
                                            placeholder="Datum des Wechsels"
                                            value={fromDate}
                                            onChange={e => setFromDate(e.target.value)}
                                            min={new Date().toISOString().split("T")[0]}
                                            isValid={VALIDATOR.dateValid(fromDate)}
                                            isInvalid={formErrors.fromDate}
                                        />
                                    </FloatingLabel>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody> :
                
                view === "loading" ? 
                    <ModalBody>
                        <div className="text-center">
                            <Spinner animation="border" className="text-energo" />
                        </div>
                    </ModalBody> : 

                view === "done" ? 
                    <ModalBody className="text-center">
                        <h3 className="text-energo"><FaCircleCheck size={60} /></h3>
                        <br />
                        <p className="text-muted">
                            Vielen Dank für die Mitteilung zum Verwaltungswechsel. 
                            Wir werden diesen entsprechend bearbeiten und alle 
                            weiteren Schritte veranlassen.
                        </p>
                    </ModalBody> :
                
                view === "error" ?
                    <ModalBody className="text-center">
                        <h3 className="text-danger"><FaCircleXmark size={60} /></h3>
                        <p className="text-muted">{apiError}</p>
                    </ModalBody>
            
            :null}
            <ModalFooter>
                {
                    view === "default" ?
                        <Button onClick={() => sendData()} variant="energo">Absenden</Button> :
                    view === "done" ?
                        <Button onClick={() => setShow(false)} variant="energo">Schließen</Button> :
                    view === "error" ?
                        <Button onClick={() => setView("form")} variant="warning">Erneut versuchen</Button> :
                    null
                }
            </ModalFooter>
        </Modal>
    )
}
export default ChangeHwModal;